import script from "./ScreenTrack.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenTrack.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenTrack.vue?vue&type=style&index=0&id=c8176e8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8176e8e"]])

export default __exports__